import { AppInsightsQueryRequest, AppInsightsQueryResponse } from '../types/AppInsightsTypes';
import config from '../config/config';
import { msalInstance } from '../index';
import { apiRequest } from '../authConfig';

const API_BASE_URL = config.apiBaseUrl;

class AppInsightsService {
  private async getAuthHeaders(): Promise<HeadersInit> {
    const accounts = msalInstance.getAllAccounts();

    if (accounts.length === 0) {
      throw new Error('No authenticated user found');
    }

    try {
      const response = await msalInstance.acquireTokenSilent({
        ...apiRequest,
        account: accounts[0],
      });
      return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${response.accessToken}`,
      };
    } catch {
      const response = await msalInstance.acquireTokenPopup(apiRequest);
      return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${response.accessToken}`,
      };
    }
  }

  async queryAppInsights(request: AppInsightsQueryRequest): Promise<AppInsightsQueryResponse> {
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/appinsights/query`, {
      method: 'POST',
      headers,
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body.error || `Request failed: ${response.statusText}`);
    }

    return await response.json();
  }

  async getCustomers(): Promise<string[]> {
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/appinsights/customers`, { headers });

    if (!response.ok) {
      throw new Error(`Failed to get customers: ${response.statusText}`);
    }

    return await response.json();
  }

  async getEnvironments(customer: string): Promise<string[]> {
    const headers = await this.getAuthHeaders();
    const response = await fetch(
      `${API_BASE_URL}/appinsights/environments?customer=${encodeURIComponent(customer)}`,
      { headers }
    );

    if (!response.ok) {
      throw new Error(`Failed to get environments: ${response.statusText}`);
    }

    return await response.json();
  }
}

const appInsightsService = new AppInsightsService();
export default appInsightsService;
